import React from 'react'
import './loading.scss'
import { useLanguage } from '@/hooks/useLanguage'
function Loading() {
  const { language } = useLanguage()
  return <div className={ `${language === 'ar' ? 'custom-loading-ar' : 'custom-loading'}` } />
}

export default Loading
